<template>
  <div v-if="loading" class="flex justify-center items-center h-[240px]">
    <img class="w-64" src="/images/gifs/loading.gif" />
  </div>
  <div v-show="!loading">
    <p>{{
      `This new card will be used for your next invoice and your current card ${creditCardText} will be deleted`
    }}</p>
    <ChargifyIframes
      :chargify-client
      :editing="true"
      :show-disclaimer="false"
      @loaded="onLoaded"
      @form-ref-saved="(form) => (chargifyForm = form)"
    />
    <div class="flex justify-start gap-16">
      <BittsButton
        text="Cancel"
        variant="ghost"
        size="x-small"
        @click="emit('return-to-summary')"
      />
      <BittsButton
        text="Save"
        variant="outline"
        size="x-small"
        @click="() => handleGetToken(() => emit('return-to-summary'))"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { BittsButton } from '@crossbeam/bitts';

import { useChargify } from '@/composables/useChargify';

import ChargifyIframes from './ChargifyIframes.vue';

const { creditCardText } = defineProps<{
  creditCardText: string;
}>();

const emit = defineEmits<(e: 'return-to-summary') => void>();

const { chargifyClient, chargifyForm, handleGetToken, loading, onLoaded } =
  useChargify();
</script>

<style lang="pcss" scoped>
p {
  @apply text-neutral-text text-sm;
}
</style>
